import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { SelectableRow } from 'core/components/table/selectable-row';
import { AuthContext } from 'core/components/auth';
import { dateTimeFormatterInUserTimezone } from 'core/helpers/formatters';
import useStyles from './legacy-offer-results.styles';
import { staffOfferLink } from 'core/helpers/bridge-link-opened';
import { abbreviateOfferRep, deriveEligibleOffers, deriveOfferTermPrices } from './offer-results.helpers';
import { Cell, deriveAddress } from './offer-item';

// The offer search row as it was before #36395, kept for the brands that haven't taken the redesign
// (see the offerSearchRedesign brand flag). Delete it once every brand has the flag on.

const LegacyOfferItem = ({ offer }) => {
  const classes = useStyles();
  const history = useHistory();
  const { canQuote, viewOnly } = useContext(AuthContext);

  const onOfferEdit = useCallback(() => {
    const { id } = offer;
    if (canQuote || viewOnly) {
      history.push(`/offer/${id}`);
    }
  }, [offer, canQuote, viewOnly, history]);

  const offerLink = staffOfferLink(offer.id);
  const hasPermission = canQuote || viewOnly;

  return (
    <SelectableRow hover id={offer.id} onClick={onOfferEdit} data-cy="row">
      <Cell hasPermission={hasPermission} offerLink={offerLink} classes={classes}>
        {offer.quote.fname}
      </Cell>
      <Cell hasPermission={hasPermission} offerLink={offerLink} classes={classes}>
        {offer.quote.lname}
      </Cell>
      <Cell hasPermission={hasPermission} offerLink={offerLink} classes={classes}>
        {deriveAddress(offer.quote.submittedAddress)}
      </Cell>
      <Cell hasPermission={hasPermission} offerLink={offerLink} classes={classes}>
        {deriveEligibleOffers(offer.options)}
      </Cell>
      <Cell hasPermission={hasPermission} offerLink={offerLink} classes={classes}>
        {/* The cell's link is a flex row; the wrapper keeps the prices stacking as block lines. */}
        <span className={classes.prices}>
          {deriveOfferTermPrices(offer.options).map((price, index) => (
            // One line per product, in Eligible Offers order ("Renters & Auto" → renters, then auto).
            <span key={`${index}-${price}`} className={classes.price}>
              {price}
            </span>
          ))}
        </span>
      </Cell>
      <Cell hasPermission={hasPermission} offerLink={offerLink} classes={classes}>
        <span className={classes.rep} title={offer.quote.rep || undefined}>
          {abbreviateOfferRep(offer.quote.rep)}
        </span>
      </Cell>
      <Cell hasPermission={hasPermission} offerLink={offerLink} classes={classes}>
        {offer.updatedDateTime && <div>{dateTimeFormatterInUserTimezone(offer.updatedDateTime)}</div>}
      </Cell>
    </SelectableRow>
  );
};

LegacyOfferItem.propTypes = {
  offer: PropTypes.object.isRequired
};

export default LegacyOfferItem;
